var $ = require('jQuery');
var _ = require('underscore');

/**
 * Field disabler.
 *
 * Usage:
 *   var fieldDisabler = new FieldDisabler();
 *   fieldDisabler.disableFields(fieldConfiguration, writeAccessAttribute);
 *
 */
module.exports = function() {

    /**
     * Disable fields based on the field configuration
     *
     * @param {Object} fieldConfiguration
     * @param {String} writeAccessAttribute
     */
    this.disableFields = function (fieldConfiguration, writeAccessAttribute) {
        _.each(fieldConfiguration, function (field) {
            if (!field[writeAccessAttribute]) {
                var fieldContainer = $('.formField' + field.slug);
                var lockIcon = '<span class="af-icons af-icons-lock"></span>';

                // Add lock to label
                fieldContainer.find('.field-label').children('label').prepend(lockIcon);

                // Disable inputs
                fieldContainer.find('input, select, textarea').each(function () {
                    $(this).prop('disabled', true);
                });

                // File upload fields need to be handled differently
                if (fieldContainer.find('.upload-standalone').length) {
                    fieldContainer.find('.upload-button').remove();
                    fieldContainer.find('.upload-details-container').remove();
                }

                // Table fields
                if (fieldContainer.find('.table-field').length) {
                    fieldContainer.find('.delete-row').remove();
                    fieldContainer.find('tfoot').remove();
                }
            }
        });
    };

};
